import React, { useState } from "react";
import Logo from '../../../assets/icon/common/logo_color.svg';
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { Swiper, SwiperSlide } from "swiper/react";
import styled from 'styled-components';
import { Navigation, Autoplay } from "swiper";
import { responsiveFont, responsivePaddingHorizontal, responsiveImageSize } from '../../common/responsive.utils';

import BackgroundImage1_Web from '../../../assets/images/partner/webBackgroundImage1.png';
import BackgroundImage2_Web from '../../../assets/images/partner/webBackgroundImage2.png';
import BackgroundImage1_Mobile from '../../../assets/images/partner/image_001.png';
import BackgroundImage2_Mobile from '../../../assets/images/partner/image_002.png';
import "swiper/css";
import "swiper/css/pagination";

const StyledSwiper_Web = styled(Swiper)`
    width:  700px;
    height: 880px;
`;

const StyledSwiperSlide_Web = styled(SwiperSlide)`
    padding: 0;
    margin: 0;
    box-sizing: border-box;
`;

const StyledSwiper_Mobile = styled(Swiper)`
    width: 100vw;    
    height: 100%;
    padding: 0 6vw;
    margin: 0; 
    box-sizing: border-box;
`;

const StyledSwiperSlide_Mobile = styled(SwiperSlide)`
    width: 52.1063vw;       
    height: 60.6897vh;
    margin: 0;
    box-sizing: border-box;
    padding: 0 3vw;
    img {
        width: 100%;
        height: 100%;
        transition: all 0.3s ease;
    }
`;

const Component01 = ({ ...props }): React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();
    const navigate = useNavigate();
    const slideImages = [BackgroundImage1_Web, BackgroundImage2_Web];
    const [activeIndex, setActiveIndex] = useState(0);
    
    const onMain = () => navigate("/");
    const onSitter = () => navigate("/sitter");

    return (
        <>
            {isWeb ? (
            <> 
                <div style={styles.webScreen_Web}>
                    <div style={styles.component01Header_Web}>
                        <img src={Logo} alt="" style={styles.component01Logo_Web} />
                        <div style={styles.component01RowCon_Web}>
                            <div style={styles.component01Btn_Web} onClick={onMain}>
                                <p style={styles.component01Txt_Web}>우주펫 소개</p>
                            </div>
                            <div style={{ width: 10 }} />
                            <div style={styles.component01Btn_Web} onClick={onSitter}>
                                <p style={styles.component01Txt_Web}>이웃시터 지원하기</p>
                            </div>
                        </div>
                    </div>

                    <div style={{ height: 7 }} />

                    <div style={styles.componentCon_Web}>
                        <div style={{ display: "flex", flexDirection: "column", marginTop: 110 }}>
                            <p style={styles.webTitleTxt_Web}>
                                펫 호텔 ∙ 유치원을 위한<br />
                                예약 관리 시스템 <br />
                                우주펫 파트너
                            </p>
                            <div style={{ height: 7 }} />
                            <p style={styles.webSubTitleTxt_Web}>
                                지금 가입하고, 예약 관리 <span style={styles.textBold_Web}>평생 무료</span>로 시작해 보세요
                            </p>
                        </div>

                        <div style={styles.slideContainer_Web}>
                            <StyledSwiper_Web
                                slidesPerView={1.5}
                                centeredSlides={false}
                                loop={true}
                                allowTouchMove={true}
                                modules={[Navigation, Autoplay]}
                                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                                autoplay={{
                                    delay: 5000, 
                                    disableOnInteraction: false, 
                                }}
                                
                            >
                                {slideImages.map((img, idx) => {
                                    const isActive = idx === activeIndex;
                                    return (
                                        <StyledSwiperSlide_Web key={idx}>
                                            <img
                                                src={img}
                                                alt=""
                                                style={isActive ? styles.selectedItem_Web : styles.previewItem_Web}
                                            />
                                        </StyledSwiperSlide_Web>
                                    );
                                })}
                            </StyledSwiper_Web>
                            <div style={styles.gradientMask_Web} />
                        </div>
                    </div>
                </div>
            </>
            ) : (
            <>
                <div style={{ height: "5vh" }} />

                <p style={styles.titleTxt01_Mobile} >
                    펫 호텔 ∙ 유치원을 위한<br />
                    예약 관리 시스템<br />
                    우주펫 파트너
                </p>

                <div style={{ height: "1.8750vw" }} />

                <p style={styles.contentTxt_Mobile}>
                    지금 가입하고, 예약 관리 <span style={styles.contentTxtSty_Mobile}>평생 무료</span>로 시작해 보세요<br />
                </p>

                <div style={{ height: "3vh" }} />

                <StyledSwiper_Mobile
                    slidesPerView={1.25} 
                    centeredSlides={false}
                    pagination={{ clickable: true }}
                    modules={[Navigation, Autoplay]}
                    loop={true}
                    onActiveIndexChange={(value) => {
                        setActiveIndex(value.activeIndex % 2);
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                >
                    <StyledSwiperSlide_Mobile>
                            <img src={BackgroundImage1_Mobile} alt="" style={activeIndex === 0 ? styles.selectedItem_Mobile : styles.unSelectedItem_Mobile} />
                    </StyledSwiperSlide_Mobile>
                    <StyledSwiperSlide_Mobile>
                            <img src={BackgroundImage2_Mobile} alt="" style={activeIndex === 1 ? styles.selectedItem_Mobile : styles.unSelectedItem_Mobile} />
                    </StyledSwiperSlide_Mobile>
                </StyledSwiper_Mobile>
            </>
            )}
        </>
    );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
    webScreen_Web: { width: "100%", minWidth: "320px", boxSizing: "border-box", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none", userSelect: "none" },
    component01Logo_Web: { width: responsiveImageSize(37, 66), height: responsiveImageSize(30, 66) },
    component01RowCon_Web: { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" },
    component01Btn_Web: { paddingTop: "22px", paddingLeft: "20px", paddingRight: "20px", paddingBottom: "22px" },
    component01Txt_Web: { padding: "0", margin: "0", fontFamily: "'Pretendard'", fontSize: responsiveFont(15, 24), fontWeight: "500", lineHeight: "120%", letterSpacing: "-2%", textAlign: "left", color: "#454A50" },
    webTitleTxt_Web: { padding: "0", margin: "0", fontFamily: "'Pretendard'", fontSize: responsiveFont(22, 40), fontWeight: "700", lineHeight: "140%", letterSpacing: "-3%", textAlign: "left", color: "#1B1D1F" },
    webSubTitleTxt_Web: { padding: "0", margin: "0", fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: "400", lineHeight: "140%", letterSpacing: "-3%", textAlign: "left", color: "#62686D" },
    textBold_Web: { fontFamily: "'Pretendard'", fontWeight: "700", fontSize: responsiveFont(14, 24), lineHeight: "140%", letterSpacing: "-3%", color: "#8B4DFF" },
    component01Header_Web: { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingLeft: "5vw", paddingRight: "9.3750vw", paddingBottom:"1.5278vw"},
    componentCon_Web: { display: "flex", margin: 0, flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", paddingLeft: responsivePaddingHorizontal(24, 88) },
    slideContainer_Web: { position: "relative", paddingRight:"30px", height: "880px", overflow: "hidden" },
    selectedItem_Web: { transform: "scale(1)", opacity: 1, width: responsiveImageSize(210, 420), height: responsiveImageSize(390, 780), transition: "all 0.4s ease" },
    previewItem_Web: { transform: "scale(0.9) translateX(-30px)", opacity: 0.7, width: responsiveImageSize(210, 420), height: responsiveImageSize(390, 780), transition: "all 0.4s ease" },
    gradientMask_Web: { position: "absolute", top: 0, right: 0, width: "250px", height: "100%",pointerEvents: "none", background: "linear-gradient(to left, white 0%, rgba(255,255,255,0) 100%)",zIndex: 3,},

    titleTxt01_Mobile: { paddingTop: 0, paddingBottom: 0, paddingRight: 0,margin: 0, paddingLeft: responsivePaddingHorizontal(24, 88), fontSize: responsiveFont(22, 40), fontFamily: "'Pretendard'", fontWeight: 700, letterSpacing: "-3%", lineHeight: "140%", color: "black", whiteSpace: "nowrap", textShadow: "none", },
    contentTxt_Mobile: { paddingTop: 0, paddingBottom: 0, paddingRight: 0, margin: 0, paddingLeft: responsivePaddingHorizontal(24, 88), fontSize: responsiveFont(14, 24), fontFamily: "'Pretendard'", fontWeight: 400, letterSpacing: "-3%", lineHeight: "140%", color: "#62686D", whiteSpace: "normal", textShadow: "none", },
    contentTxtSty_Mobile: { fontSize: responsiveFont(14, 24), fontFamily: "'Pretendard'", fontWeight: 700, letterSpacing: "-3%", lineHeight: "6.1250vw", color: "#8B4DFF", whiteSpace: "normal", textShadow: "none", },
    selectedItem_Mobile: { transform: "scale(1)",  opacity: 1 },
    unSelectedItem_Mobile: { transformOrigin: "center", opacity: 1, transform: "scale(0.9) translateX(-10px)", }
});

export default Component01;
